"use client";
import { Separator } from "@/components/ui/separator";


export default function Team1() {
  return (
    <section className="w-full py-12 lg:py-[4.5rem]">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-8 px-5 md:px-8 lg:px-0 lg:flex-row lg:items-center lg:justify-between">
        {/* Left Column: Text */}
        <div className="px-4 md:px-10 lg:px-0 lg:w-1/2">
          <h2 className="text-2xl font-bold md:text-4xl">
            Meet Our Dedicated Construction Team
          </h2>
          <p className="mt-4 text-sm text-muted-foreground sm:text-base">
            At Bishop Mercier, our expert professionals deliver outstanding
            residential, commercial, and industrial projects throughout
            Montreal.
          </p>
          <p className="mt-4 text-sm text-muted-foreground sm:text-base">
            Based in Westmount, our team combines deep local knowledge with
            years of construction experience to ensure exceptional results.
          </p>
          <Separator className="my-8 w-1/2" />
          <a href="/about" className="inline-block">
            <button className="bg-primary text-primary-foreground px-6 py-2 rounded-md font-semibold shadow hover:bg-primary/90 transition-colors">
              More About Us
            </button>
          </a>
          <p className="text-sm font-semibold sm:text-base">
            <span className="font-normal"></span>
          </p>
        </div>

        {/* Right Column: Image */}
        <div className="lg:w-2/5 aspect-[1.2] max-lg:max-h-[22vh]">
          <img
            src="/images/cfc096485619d7063ebe1e919483a1de.png"
            className="h-full w-full rounded-lg object-cover shadow-lg"
          />
        </div>
      </div>
    </section>
  );
}
